import { showErrorNotification, showSuccessNotification } from "../components/common/NotiService";
import { AGENT_STATE, MODES } from "../constants";
import { callEndActions, pauseAfterCall, pauseToggle, setCallDetails, setClick2Call, setIsCallAttended, setIsCallBackCallNotAttended, setIsCallEnded, setIsCallIncomming, setIsComponentOnCall, setScreenpopURL, setWrapUpTimeExceeded, updateTranscribe } from "../context/callSlice";
import { addNewTab, removeTab, setActiveTab } from "../context/dashboardSlice";
import { clearChatDisposition, handleChatRemove, handleDeleteChats, handleIncommingMsgs, handlePullChatsDialog, pauseAfterSession, setChatParkingApiCount, setChatScreenpops, showExceededTimelimit, showPauseAfterSessionTime, updateEmailConversation } from "../context/digitalSlice";
import { store } from "../context/store";
import { setAgentStateDuration, setAutoUpdateAgentState, setPauseReason, setReUpdateTimer, setWrapUpTime } from "../context/timerSlice";
import { handleDispositionEnable, handleMultiDisposition, loading, minimizeApp, minimizeCall, minimizeTB, setAgentRelaseEvnTime, setAgentState, setCallOnChatORChatOnCallAvailable, setDispositionReqbody, setDispositionValues, setIsExceptionState, setLogoutTimer, setMode, setSipDisconnectPause, setWarmTransferdisableHoldButton, setWarmTransferEnableCallEndbutton } from "../context/toolbarSlice";
import { aToolbar } from "../toolbar";
import { agentService, getIVRJourney } from "./agent.service";
import HttpService from "./http.service";
import LocalStorageService from "./localstorage.service";
import Logger from "./logger.service";
import { forceCloseAllNotification, handleTbNotifications } from "./notificationHandler";
import  { handleSipAutoAnswer, handleSipDisconnect } from "./sip.service";
import { displayChatOnCallMiniWindow, getAgentData, getParam, handleScreenRecording, isSettingEnabled, maskEntireNumber, playMsgAlert, updateTimer, getRoleStatus, removeScreenpopFromStorage, StartVideoScreenRecording, getIHstatus, onReadyGetParkingChatsCount, isUcidRecordingMode, updateScreenRecordingUcid } from "./util";
import MessageService from "./message.service";
import dayjs from "dayjs";

export function handleCallAnswered(message) {
    store.dispatch(setCallOnChatORChatOnCallAvailable(false));
    const isCallBackCallNotAttended = store.getState().call.isCallBackCallNotAttended.cbState;
    let newParam = store.getState().call.callDetails || {}
    if (store.getState().call.callDetails.uui !== undefined && store.getState().call.callDetails.uui !== null && store.getState().call.callDetails.uui !== '') {
        message.uui = store.getState().call.callDetails.uui;
    }
    if (message && message.skillName) { // Removes '#T' or '%23T' from the skill name string.
        message.skillName = sanitizeSkillName(message.skillName);
    }
    newParam = { ...newParam, ...message }
    aToolbar !== undefined && aToolbar.trigger("busyAgent", [newParam]);

    if (isUcidRecordingMode()) {
        // const isBarginRecording = store.getState().toolbar.isBarginRecording;
        // if (!isBarginRecording) {
        handleScreenRecording("busyAgent", "resume");
        console.log("screen->Recording :: busy agent, resuming the agent screen");
        // }
    }
    handleNewIncommingCall(message, false);

    if (newParam && newParam.callType && newParam.callType === "IncomingCall" &&
        (newParam.calltype === "InBound" || newParam.calltype === "IncomingCall" || newParam.callData === "InBound" || newParam.callData === "IncomingCall")) {
        getIVRJourney()
    }
    forceCloseAllNotification();
    store.dispatch(setIsComponentOnCall(true));
    store.dispatch(setIsCallEnded(false));
    store.dispatch(setIsCallAttended(true));
    store.dispatch(setReUpdateTimer(true));
    const IdeskIntegrationId = HttpService.getURL('idesk_integration_id')
    const IdeskScreenPopUrl = HttpService.getURL('idesk_screenpop_url')
    const contactManagerIntegrationId = HttpService.getURL('contact_manager_integration_id');
    const contactManagerScreenpopUrl = HttpService.getURL('contact_manager_screenpop_url')
    if (message && message.screenPopOn === "PLUGIN" && message.screenPop === IdeskIntegrationId) {
        const newObj = { ...message, screenPop: IdeskScreenPopUrl }
        appendNewObjWithCallData({ busyAgentData: newObj, ...newObj });
    }
    else if (message && message.screenPopOn === "PLUGIN" && message.screenPop === contactManagerIntegrationId) {
        const newObj = { ...message, screenPop: contactManagerScreenpopUrl }
        appendNewObjWithCallData({ busyAgentData: newObj, ...newObj });
    }
    else {
        appendNewObjWithCallData({ busyAgentData: message, ...message }); // busy agent call detsails
    }
    if (isCallBackCallNotAttended) {
        store.dispatch(setIsCallBackCallNotAttended({
            cbState: false,
            cbId: null,
            cbNumber: null,
        }));;
    }
    window.parent.postMessage({ action: "busyAgent", token: store.getState().call.callDetails }, "*");
}
function sanitizeSkillName(skillName) { // Removes '#T' or '%23T' from the skill name string.
    try {
        if (!skillName) return '';
        const decodedSkillName = decodeURIComponent(skillName);
        if (decodedSkillName.includes('#T')) {
            return decodedSkillName.split('#T')[0];
        }
        return decodedSkillName;
    } catch (e) {
        console.log("error while removeing #T from skillName");
    }
}
export function handleScreenPopClose(windowId, type) {
    const DONT_CLOSE_SPOP = store.getState().toolbar.params.DONT_CLOSE_SPOP;
    const storedWindows = JSON.parse(localStorage.getItem('windows')) || [];
    const windowToClose = storedWindows.find((win) => win.id === windowId);
    if (windowToClose && DONT_CLOSE_SPOP === 'false') {
        const windowName = `window${windowToClose.id}`;
        const windowToCloseRef = window.open('', windowName);
        if (windowToCloseRef) {
            windowToCloseRef.close();
        }
        const updatedWindows = storedWindows.filter((win) => win.id !== windowId);
        localStorage.setItem('windows', JSON.stringify(updatedWindows));
    }
    else {
        const callData = store.getState().call.callDetails || {}
        let loginDetails = store.getState().toolbar.loginDetails
        if (callData && callData.screenPopMode === "1" && DONT_CLOSE_SPOP === 'false') {
            console.log(callData.screenPopMode);
            if (type === 'call' || type === 'chatCall') {
                store.dispatch(removeTab('Pop CRM'));
                removeScreenpopFromStorage('Pop CRM');
                store.dispatch(setScreenpopURL(null));
            }
        }
        if (windowId && loginDetails.agentInfo.user.screenPopMode === 1 && DONT_CLOSE_SPOP === 'false') {
            if (type === 'call' || type === 'chatCall') {
                store.dispatch(removeTab('Pop CRM'));
                removeScreenpopFromStorage('Pop CRM');
                store.dispatch(setScreenpopURL(null));
            }
            const updatedWindows = storedWindows.filter((win) => win.id !== windowId);
            localStorage.setItem('windows', JSON.stringify(updatedWindows));
        }
        store.dispatch(removeTab('Script'));
    }
}

export function handleChatScreenPopCloseOnUserInactivity(SessionId) {
    const chatScreenPopList = store.getState().digital.chatScreenPops;
    if (chatScreenPopList && chatScreenPopList.length > 0) {
        const disposedTab = chatScreenPopList.filter((win) => win ? win.sessionId === SessionId : false);
        if (disposedTab && disposedTab.length > 0 && store.getState().toolbar.params.DONT_CLOSE_SPOP === 'false') {
            store.dispatch(removeTab(disposedTab[0].name))
            const tabs = chatScreenPopList.filter((win) => win.sessionId !== SessionId);
            store.dispatch(setChatScreenpops(tabs));
        }
    }
}

export async function agentReleaseAfterCompleteUserInactivity(data, type, chatCustSessionId) {
    let agentRes = await MessageService.agentRelease(data)
    if (agentRes.resp.includes("Success")) {
        if (type === "transfer") {
            handleChatScreenPopCloseOnUserInactivity(chatCustSessionId)
        }
        localStorage.removeItem("pauseAfterSessionTime")
        store.dispatch(showExceededTimelimit(false))   // to show timer in red color
        store.dispatch(setAgentState(AGENT_STATE.READY));
        if (store.getState().digital.pauseAfterSession) {
            pauseAgent(store.getState().digital.pauseAfterSessionReason);
        }
        showSuccessNotification("State Successfully changed to Ready")
        Logger.info("Agent State Successfully changed to Ready")
    }
    else {
        showErrorNotification("Unable to change the Agent state to Ready mode");
        Logger.info("unable to change the agent state to ready mode")
    }
}

export async function handleDropCall(message) {
    store.dispatch(setCallOnChatORChatOnCallAvailable(false));
    const PAUSE_AGENT_TOGGLE = (getParam("PAUSE_AGENT_TOGGLE") === "true" || getParam("PAUSE_AGENT_TOGGLE") === true) || false;
    const selectedPaueReason = store.getState().timer.pauseReason;
    store.dispatch(minimizeApp(false))
    store.dispatch(minimizeTB(false))
    store.dispatch(setWarmTransferEnableCallEndbutton(false));
    store.dispatch(setWarmTransferdisableHoldButton(false));
    try {
        let dropCallData = store.getState().call.callDetails || {}
        if (message && typeof message === 'object' && Object.keys(message).length > 0) {
            dropCallData = { ...dropCallData, ...message }
            if (message.latestToken && typeof message.latestToken === 'object' && Object.keys(message.latestToken).length > 0) {
                dropCallData = { ...dropCallData, ...message.latestToken }
            }
        }
        window.parent.postMessage({ action: "dropCall", token: dropCallData }, "*");
    } catch (e) {
        console.log("error in drop call event", e)
    }
    let mode = store.getState().toolbar.agent.mode;

    if (message.type === "agentReleaseWOACW") {
        if (isUcidRecordingMode()) {
            handleScreenRecording("agentReleaseWOACW", "pause");
            console.log("screen->Recording :: agent release WOACW, so screen recording paused")
            const isBarginRecording = store.getState().toolbar.isBarginRecording;
            if (isBarginRecording) {
                console.log("screen->Recording :: bargin in progress, so resuming the screen recording");
                handleScreenRecording("bargin", "resume");

            }
        }
    }
    if (store.getState().call.callDetails.uui !== undefined && store.getState().call.callDetails.uui !== null && store.getState().call.callDetails.uui !== '') {
        message.uui = store.getState().call.callDetails.uui;
    }
    if (message && message.type === "pauseFromApi") {
        message.timeLimit = message.timeLimit ? message.timeLimit : 0
        pauseAgent(message)
    }
    try {
        const triggerFrom = message?.triggerFrom || "others"
        if (message.type !== "agentReleaseWOACW") {
            if (isUcidRecordingMode()) {
                // const isBarginRecording = store.getState().toolbar.isBarginRecording;
                // if (!isBarginRecording) {
                console.log("screen->Recording :: drop call, so pausing the screen recording");
                handleScreenRecording("dropCall", "pause");
                // }
            }
            if (triggerFrom !== "forceRelease") {
                const params = { ...store.getState().call.callDetails, ...message, event: "Disconnect", endTime: convertingToDateTimeStringFormat(), customerStatus: message.dialStatus, message }
                aToolbar !== undefined && aToolbar.trigger("dropCall", [params]);
            } else {
                console.log("triggerFrom force release, hence not triggering dropCall")
            }
            (message && message.dialStatus) && showErrorNotification(message.dialStatus)
        } else {
            if (triggerFrom !== "forceRelease") {
                const params = { ...store.getState().call.callDetails, ...message, event: "Disconnect", endTime: convertingToDateTimeStringFormat(), customerStatus: message.dialStatus, message }
                aToolbar !== undefined && aToolbar.trigger("dropCall", [params]);
            } else {
                console.log("triggerFrom force release, hence not triggering dropCall")
            }
        }
        localStorage.removeItem('callStartTime');
    } catch (e) {
        console.log("error in removing callStartTime from localstorage", e)
    }
    handleScreenPopClose(message.ucid, 'call');
    LocalStorageService.removeItem("callTime");
    appendNewObjWithCallData({ agentReleaseData: message, ...message });
    store.dispatch(setIsComponentOnCall(false));
    if (mode === 'blended') {
        store.dispatch(minimizeCall(false))
    }
    store.dispatch(setIsCallAttended(false));
    handleNewIncommingCall(message, false);
    store.dispatch(callEndActions());
    forceCloseAllNotification();
    store.dispatch(setReUpdateTimer(true))
    removeTranscribeTab();

    if (message && message.isException) {  // used for Exception Calls Allowed per Agent exception
        let temp = {
            reason: "EXCEPTION",
            timeLimit: 0
        }
        store.dispatch(setPauseReason(temp));
        store.dispatch(setIsExceptionState(true));
        store.dispatch(setReUpdateTimer(true));
        store.dispatch(setAgentStateDuration(0));
        store.dispatch(handleDispositionEnable(false));
        LocalStorageService.setItem("maxPauseTime", temp.timeLimit);
        store.dispatch(setAgentState(AGENT_STATE.NOT_READY));
    } else {
        if (PAUSE_AGENT_TOGGLE && selectedPaueReason) {
            store.dispatch(setIsCallAttended(false));
            pauseAgent(selectedPaueReason)
        }
    }
}
export function handleToolbarRelease() {
    store.dispatch(minimizeApp(false))
    store.dispatch(minimizeTB(false))
    LocalStorageService.removeItem("callTime");
    store.dispatch(setIsComponentOnCall(false));
    store.dispatch(setIsCallAttended(false));
    store.dispatch(callEndActions());
    forceCloseAllNotification();
    store.dispatch(setReUpdateTimer(true))
    store.dispatch(setAgentState(AGENT_STATE.READY))
}
export function handleAgentRelease(message) {
    try {
        store.dispatch(minimizeApp(false))
        store.dispatch(minimizeTB(false))
        let mode = store.getState().toolbar.agent.mode;
        const params = {
            ...store.getState().call.callDetails, ...message,
            event: "Disconnect",
            endTime: convertingToDateTimeStringFormat(),
            message
        }
        aToolbar !== undefined && aToolbar.trigger("dropCall", [params]);
        LocalStorageService.removeItem('callStartTime')
        appendNewObjWithCallData({ agentReleaseData: message, ...message });
        store.dispatch(setIsCallIncomming(false))
        store.dispatch(setIsCallEnded(true));
        // Reset the wrap-up counter at ACW entry so each ACW starts from a clean
        // elapsed value, regardless of whether the previous cycle's release path
        // cleared it (client-timer/releaseAgent resets are guarded by isCallEnded
        // and can be skipped when the next call arrives during the async release).
        store.dispatch(setWrapUpTimeExceeded(false));
        store.dispatch(setWrapUpTime(0));
        store.dispatch(setAgentRelaseEvnTime(dayjs().format()));
        LocalStorageService.setItem("CancelDispositionScreen", false)
        store.dispatch(setReUpdateTimer(true));
        store.dispatch(setIsComponentOnCall(false));
        if (mode === 'blended') {
            store.dispatch(minimizeCall(false))
        }
        store.dispatch(setIsCallAttended(false));
        forceCloseAllNotification();
        window.parent.postMessage({ action: "dropCall", token: params }, "*");
    } catch (e) {
        console.log("error in handleAgentRelease", e)
    }
}

export function handleCallEndData(message) {
    LocalStorageService.removeItem("callTime")
    let mode = store.getState().toolbar.agent.mode;
    if (store.getState().call.isComponentOnCall) {
        store.dispatch(setIsComponentOnCall(false));
        if (mode === 'blended') {
            store.dispatch(minimizeCall(false))
        }
        store.dispatch(setIsCallAttended(false));
    }
}

export function handleNewIncommingCall(message, isCallIncomming) {
    let answeredChats = store.getState().digital.answeredChats;
    let unansweredChats = store.getState().digital.unansweredChats;
    const mode = store.getState().toolbar.agent.mode;
    if (isCallIncomming) {
        isCallIncomming ? handleTbNotifications({ isCallIncomming: false, alertType: 'Incoming Call', msg: message.callData !== undefined ? message.callData : "Inbound", type: "incomingCall" }) : forceCloseAllNotification();
    }
    if (isCallIncomming && mode === "blended" && ((Object.values(unansweredChats).length > 0 || Object.values(answeredChats).length > 0))) {
        // store.dispatch(handleChatAcceptStatus(false));
        store.dispatch(setCallOnChatORChatOnCallAvailable(true));
        store.dispatch(setIsCallIncomming(true));
    } else {
        store.dispatch(setIsCallIncomming(isCallIncomming));
    }
    store.dispatch(setReUpdateTimer(true));
}

export function handleNewIncommingMsg(inCommingMsg) {
    try {
        const answeredChats = store.getState().digital.answeredChats;
        if (answeredChats?.[inCommingMsg.chatCustSessionId]?.chatDetails?.channelType === 'email') {
            store.dispatch(updateEmailConversation(inCommingMsg));
        } else {
            displayChatOnCallMiniWindow();
            const { showMinimizedCall } = store.getState().toolbar;
            const { isCallAttended } = store.getState().call;
            const { mode } = store.getState().toolbar.agent;
            const { isSip } = store.getState().toolbar.loginDetails;
            const isChatAudioDisabled = store.getState().toolbar.isChatAudioDisabled;
            const Role_Chat_call = getRoleStatus('ROLE_CHAT_CALL');
            const isAgentBusy = (isCallAttended || showMinimizedCall);
            const shouldMute = isSip && mode === "blended" && Role_Chat_call && isChatAudioDisabled && isAgentBusy;
            if (!shouldMute) {
                playMsgAlert();
            }
            try {
                let botHist = inCommingMsg && JSON.parse(inCommingMsg.chatmsg)
                if (botHist.hasOwnProperty("CHAT_BOT_HISTORY")) {
                    botHist["CHAT_BOT_HISTORY"].map((e1) => {
                        let obj = {
                            chatCustSessionId: inCommingMsg.chatCustSessionId,
                            agent: e1.bot,
                            chatmsg: e1.msg,
                            timestamp: "" + e1.ts,
                            type: e1.type
                        }
                        store.dispatch(handleIncommingMsgs(obj))
                    });
                } else {
                    store.dispatch(handleIncommingMsgs(inCommingMsg))
                }
            } catch (error) {
                store.dispatch(handleIncommingMsgs(inCommingMsg))
            }
        }

    } catch (e) {
        console.log("digital conversation parsing error :", e);
    }
}

export async function handleNewCall(messages) {
    localStorage.removeItem('timeTakenToSub');
    localStorage.removeItem('agentRelaseEvtTime');
    handleCampaignScript(messages);
    store.dispatch(setWarmTransferEnableCallEndbutton(false));
    store.dispatch(setWarmTransferdisableHoldButton(false));
    store.dispatch(handleDispositionEnable(false));
    store.dispatch(setWrapUpTimeExceeded(false));
    store.dispatch(handlePullChatsDialog(false));
    store.dispatch(setWrapUpTime(0));
    let message = messages.type === "InternalDial" ? {
        ...messages,
        callType: "InternalDial",
        callerId: messages.fromAgentNumber,
    } : messages
    LocalStorageService.setItem('callStartTime', new Date());
    let newParam = { ...message, agentId: getAgentData().agentUserName || '', startTime: convertingToDateTimeStringFormat() }
    try {
        const click2Call = store.getState().call.click2Call;
        newParam.click2Call = click2Call ?? (message.callType === "Manual Dialing" ? "agentManualDialApi" : false);
        if (click2Call !== newParam.click2Call) {
            store.dispatch(setClick2Call(newParam.click2Call));
        }
    }
    catch (e) {
        console.log("error in assigning click2call", e)
    }
    try {
        aToolbar !== undefined && aToolbar.trigger("newCall", [newParam]);
    } catch (e) {
        console.log("internal call error ", e)
    }
    if (isUcidRecordingMode()) {
        // const isBarginRecording = store.getState().toolbar.isBarginRecording;
        // if (!isBarginRecording) {
        console.log("new call resuming the screen recoding")
        updateScreenRecordingUcid(message?.ucid ?? '');
        handleScreenRecording("newCall", "resume", message?.ucid ?? '');
        // }
        const isScreenAlreadyRecording = store.getState().toolbar.isScreenRecordingEnabled;
        const SCREEN_RECORD_BY_APP = isSettingEnabled("SCREEN_RECORD_BY_APP");
        if (isScreenAlreadyRecording || SCREEN_RECORD_BY_APP) {
            console.log("screen recoding enabled so calling video screen recoding URL")
            StartVideoScreenRecording(message);
        }
    }
    const IdeskIntegrationId = HttpService.getURL('idesk_integration_id')
    const IdeskScreenPopUrl = HttpService.getURL('idesk_screenpop_url')
    const contactManagerIntegrationId = HttpService.getURL('contact_manager_integration_id');
    const contactManagerScreenpopUrl = HttpService.getURL('contact_manager_screenpop_url')
    let loginDetails = store.getState().toolbar.loginDetails;
    if (messages.screenPopOn === "PLUGIN" && messages.screenPop === IdeskIntegrationId) {
        const newObj = { ...messages, screenPop: IdeskScreenPopUrl }
        store.dispatch(setCallDetails(newObj));
    }
    else if (message && message.screenPopOn === "PLUGIN" && message.screenPop === contactManagerIntegrationId) {
        const newObj = { ...message, screenPop: contactManagerScreenpopUrl }
        appendNewObjWithCallData({ busyAgentData: newObj, ...newObj });
    }
    else {
        store.dispatch(setCallDetails(message));  // newCall details 
    }
    if (message.callType === "Manual Dialing" || message.callType === "PreviewDialing") {
        store.dispatch(setIsComponentOnCall(true));
    }
    if (message.callType === "InternalDial" || message.callType === "IncomingCall" || message.callType === "Progressive Dialing"
        || message.callType === "Conference Call" || message.callType === "Predictive Call") {
        handleNewIncommingCall(message, true);
    } else {
        handleNewIncommingCall(message, false);
    }
    if (loginDetails.isSip) {
        setTimeout(() => {
            handleSipAutoAnswer(true);
        }, 100);
    }
    try {
        if (message && message?.callerId) {
            const iframe = document.getElementById('OzonetelMyCRM');
            if (iframe && iframe.contentWindow) {
                const agentInfo = getAgentData()?.agentInfo || {};
                iframe.contentWindow.postMessage({
                    action: "mycrm",
                    data: {
                        callerId: message?.callerId || '',
                        did: message?.did || '',
                        agentId: agentInfo?.agentId || '',
                        monitorUcid: message?.monitorUcid || '',
                        agentUniqueID: message?.agentUniqueID,
                        id: agentInfo?.id || '',
                        ucid: message?.ucid || '',
                        skillName: message?.skillName || '',
                        agentData: loginDetails?.agentData || ''
                    }
                }, "*");
            } else {
                console.warn("Iframe is not open. Please check")
            }
        }
    } catch (error) {
        console.error("Error in postMessage:", error);
    }
    store.dispatch(pauseAfterCall({ type: false, reason: null }))
    store.dispatch(pauseToggle(false));
}

function handleCampaignScript(message) {
    let ENABLE_AGENT_SCRIPT = isSettingEnabled("ENABLE_AGENT_SCRIPT");
    const isMobileView = matchMedia('(max-width:650px)');
    if (ENABLE_AGENT_SCRIPT && message?.campaignScript && message?.campaignScript !== "<p><br></p>" && !isMobileView.matches) {
        store.dispatch(addNewTab("Script"));
    }
}

export async function releaseAgent(addtionalParams) {
    const AGENT_FRELEASE_ALERT = store.getState().toolbar.params.AGENT_FRELEASE_ALERT;

    const isSIPconnected = store.getState().toolbar.isSIPconnected;
    const isSip = store.getState().toolbar.loginDetails.isSip;

    let answeredChats = store.getState().digital.answeredChats;
    let unansweredChats = store.getState().digital.unansweredChats;

    store.dispatch(loading(true));
    try {
        const resp = await agentService('tbAgentRelease', {
            params: store.getState().toolbar.agent.mode.toUpperCase(),
            campId: ((store.getState().call.callDetails !== null) && (Object.keys(store.getState().call.callDetails).length > 0)) ? store.getState().call.callDetails.campaignId : null,
            ...addtionalParams
        })
        if (resp) {
            let respKeys = Object.keys(resp);
            if (respKeys.includes('resp')) {
                if (resp.resp.includes("Success") || resp.agentStatus === 'IDLE') {
                    store.dispatch(setAutoUpdateAgentState({ countDown: null, altered: true }))
                    store.dispatch(setReUpdateTimer(true));
                    addtionalParams ? addtionalParams?.mes?.includes("agentReleaseByAdmin") ? (AGENT_FRELEASE_ALERT === "true" ? showSuccessNotification("You are Force Released by Admin") : console.log("force Released by admin"))
                        :
                        showSuccessNotification("State Successfully changed to Ready") : showSuccessNotification("State Successfully changed to Ready");

                    try {
                        if (addtionalParams && addtionalParams.mes && addtionalParams?.mes?.includes("agentReleaseByAdmin") && isUcidRecordingMode()) {
                            handleScreenRecording("agentReleaseByAdmin", "pause");
                            console.log("screen->Recording :: agent release by admin, so pausing the screen recording");
                            const isBarginRecording = store.getState().toolbar.isBarginRecording;
                            if (isBarginRecording) {
                                console.log("barging in progress so resumin the recording ( agent release by admin )");
                                handleScreenRecording("bargin", "resume");

                            }
                        }
                        if (addtionalParams && addtionalParams.mes && !addtionalParams?.mes?.includes("agentReleaseByAdmin") && isUcidRecordingMode()) {
                            // const isBarginRecording = store.getState().toolbar.isBarginRecording;
                            // if (!isBarginRecording) {
                            handleScreenRecording("agentRelease", "resume");
                            // }
                        }
                    } catch (error) {
                        console.error('Error getting UCID in agentReleaseByAdmin webEventhandler:', error);
                    }
                    store.dispatch(setAgentState(AGENT_STATE.READY));
                    LocalStorageService.removeItem("maxPauseTime");
                    store.dispatch(loading(false));
                    Logger.info("State Successfully changed to Ready");
                    window.parent.postMessage({ action: "changeState", token: { state: "Ready" } }, "*");
                    store.dispatch(setDispositionValues("clear"));
                    if (store.getState().call.isCallEnded) {
                        store.dispatch(callEndActions());
                        store.dispatch(setWrapUpTime(0));
                    }
                    if (addtionalParams && addtionalParams.mes && addtionalParams?.mes?.includes("agentReleaseByAdmin") &&
                        addtionalParams.who !== "CA_App" && ((Object.keys(answeredChats).length > 0) || (Object.keys(unansweredChats).length > 0))) {
                        store.dispatch(minimizeCall(false));
                        store.dispatch(setIsComponentOnCall(false));
                        store.dispatch(handleDeleteChats());
                        store.dispatch(clearChatDisposition());
                    }
                    store.dispatch(setPauseReason(''))
                    if (!isSIPconnected && isSip) {
                        store.dispatch(setSipDisconnectPause(false));
                        handleSipDisconnect('SIP disconnected');
                    }
                    aToolbar !== undefined && aToolbar.trigger("tbAgentRelease");
                    store.dispatch(showExceededTimelimit(false)) // to show timer in red color
                }
            } else {
                const errorName = resp.message !== undefined ? resp.message : "unkown error";
                showErrorNotification(`${errorName}. Unable to change Agent state to Ready mode`);
                Logger.info(`${errorName}.unable to change agent state to ready mode`)
            }
        }
        store.dispatch(loading(false));
    }
    catch (e) {
        showErrorNotification('Unable to change Agent state to Ready')
        Logger.error(e);
        store.dispatch(loading(false));
    }
}
export async function pauseAgentOnBusyState() {
    store.dispatch(loading(true));
    try {
        let payload = {
            "agentId": getAgentData().agentInfo.id,
            "agentUniqId": getAgentData().agentUniqId,
            "customer": getAgentData().customer,
        }
        const resp = await agentService('pauseAfterSession', payload);
        if (resp.status === "Success") {
            store.dispatch(loading(false));
        }
        else {
            store.dispatch(loading(false));
        }
    }
    catch (e) {
        showErrorNotification('Unable to change Agent state to Pause');
        Logger.error(e);
        store.dispatch(loading(false));
    }
}

export async function pauseAgent(pauseReason) {
    const pauseAfterSessionEnabled = store.getState().digital.pauseAfterSession;
    const pauseAfterCallStatus = store.getState().call.pauseAfterCallStatus;
    store.dispatch(loading(true));
    try {
        const resp = await agentService('tbAgentPause', { params: pauseReason.reason + "," + store.getState().toolbar.agent.mode });
        if (resp.status === "Success") {
            localStorage.setItem("pauseTime", new Date());
            if (pauseAfterSessionEnabled) {
                store.dispatch(pauseAfterSession({ type: false, reason: null }))
                store.dispatch(showPauseAfterSessionTime(true))
            }
            if (pauseAfterCallStatus) {
                store.dispatch(pauseAfterCall({ type: false, reason: null }));
                store.dispatch(pauseToggle(false));
            }
            store.dispatch(pauseToggle(false));
            store.dispatch(setReUpdateTimer(true));
            store.dispatch(setAgentStateDuration(0));
            store.dispatch(handleDispositionEnable(false))
            showSuccessNotification(`Pause Reason: ${pauseReason.reason},TimeLimit: ${pauseReason.timeLimit} Sec`)
            Logger.info(`Agent State Successfully changed to Pause. Reason: ${pauseReason.reason},TimeLimit: ${pauseReason.timeLimit} Seconds`)
            LocalStorageService.setItem("maxPauseTime", pauseReason.timeLimit);
            store.dispatch(setAgentState(AGENT_STATE.NOT_READY));
            store.dispatch(loading(false));
            store.dispatch(setLogoutTimer(true));
            const startTime = Date.now();
            LocalStorageService.setItem("logoutStartTime", startTime);
            Logger.info('Agent State changed to Pause');
            store.dispatch(setDispositionValues("clear"));
            if (store.getState().call.isCallEnded) {
                store.dispatch(callEndActions());
                store.dispatch(setWrapUpTime(0));
            }
            if (pauseReason && pauseReason.type === "pauseFromApi") {
                store.dispatch(setPauseReason(pauseReason))
            }
            store.dispatch(setChatParkingApiCount(0));
        }
        else {
            const errorName = resp.message !== undefined ? resp.message : "unkown error";
            showErrorNotification(`${errorName}. Unable to change to Pause State`);
            Logger.info(`${errorName}.unable to change to pauseState`)
            store.dispatch(loading(false));
        }
    }
    catch (e) {
        showErrorNotification('Unable to change Agent state to Pause');
        Logger.error(e);
        store.dispatch(loading(false));
    }
}

export async function changeAgentMode(mode, additionalParams = undefined, callBackAfterChangeMode = null) {
    store.dispatch(loading(true))
    const selectedPaueReason = store.getState().timer.pauseReason;
    const isCallAttended = store.getState().call.isCallAttended;
    let actMode = (mode === undefined ? store.getState().toolbar.agent.mode : mode === MODES.DIGITAL ? 'chat' : mode).toUpperCase();
    const latestToken = (additionalParams !== undefined && additionalParams.reconnect && additionalParams.reconnect === "true") ? additionalParams.latestToken : false;
    let params = actMode + ',' + (selectedPaueReason ? "PAUSED" : isCallAttended ? "BUSY" : store.getState().toolbar.agent.state);
    if (latestToken) {
        const { type = false, callType = false } = latestToken;
        params = (callType && type !== 'dropCall') ? actMode + ',' + (type === 'busyAgent' ? 'BUSY' : (type === 'agentRelease' || type === 'agentReleaseByAdmin') ? 'ACW' : callType) : params;
        delete additionalParams.latestToken;
    }
    let resp = await agentService('tbSetAgentMode', {
        params,
        reconnect: 'false',
        reconDet: "",
        ...additionalParams
    });
    if (resp) {
        if (resp.resp === 'Success') {
            let agentState = store.getState().toolbar.agent.state;
            if (agentState !== AGENT_STATE.NOT_READY) {
                store.dispatch(setReUpdateTimer(additionalParams === undefined));
                if (callBackAfterChangeMode) {
                    callBackAfterChangeMode();
                }
            }
            else {
                store.dispatch(setReUpdateTimer(false));
            }
            store.dispatch(setMode(mode.toLowerCase()));
            Logger.info('Mode changed to: ' + mode);
            const parkingApiCallCount = store.getState().digital.parkingApiCallCount;
            if (parkingApiCallCount <= 0 && (mode.trim() === 'chat' || mode === 'blended') && agentState !== AGENT_STATE.NOT_READY) {
                onReadyGetParkingChatsCount();
            }
        } else {
            Logger.error('Failed to change mode to: webEventhandler,' + mode);
            showErrorNotification('Unable to Change Mode');
        }
        store.dispatch(loading(false))
    }
}

export async function manualDial(mode, manualCallData, phoneNumberFromApp, campaign, redial, campaignId, uui, click2Call = false) {
    store.dispatch(loading(true));
    if (click2Call) {
        store.dispatch(setClick2Call("crmClick2Call"));
    } else {
        store.dispatch(setClick2Call("toolbarClick2Call"));
    }
    const PLAY_DISCLAIMER = store.getState().toolbar.params.PLAY_DISCLAIMER;
    let phoneNumber = (phoneNumberFromApp !== undefined && phoneNumberFromApp !== null) ? phoneNumberFromApp : manualCallData.phoneNumber;
    let campId = (manualCallData?.campaign?.split("~")[0] !== null && manualCallData?.campaign?.split("~")[0] !== undefined) ? manualCallData?.campaign.split("~")[0] : (campaignId !== undefined && campaignId !== null) ? campaignId : campaign.split("~")[0];
    const params = campId + "," + phoneNumber + "," + getAgentData().phoneNumber + ",SIP:" + getAgentData().isSip;
    try {
        const resp = await agentService('tbManualDial', {
            mode: mode,
            params: params,
            playDisclaimer: PLAY_DISCLAIMER ? ((PLAY_DISCLAIMER.trim() === "-1" || PLAY_DISCLAIMER.trim() === "") ? false : PLAY_DISCLAIMER.trim()) : false,
            redial: (redial !== undefined && redial !== null && redial === true) ? "true" : "false",
            uui: (uui !== undefined && uui !== null) ? uui : "",
            obdJava: isSettingEnabled("OBD_JAVA"),
            skillName: (manualCallData && manualCallData.skillName) ? manualCallData.skillName : 0,
        });
        if (resp.status === "Error") {
            let NumberOfDigitsToShow = Number(getParam("SHOW_CUST_NUMBER_N"));
            let msg = resp?.resp || "Manual Dial Failed";
            if (NumberOfDigitsToShow <= 0) {
                const regexPattern = new RegExp(`\\b\\d{${5},}\\b`, 'g');
                msg = resp?.resp.replace(regexPattern, (match) => '*'.repeat(match.length));
            }
            else if (NumberOfDigitsToShow > 0) {  // checking if number is greater then 0 and less then or equal to number length
                msg = resp?.resp.replace(new RegExp(`\\d(?=\\d{${NumberOfDigitsToShow}})`, 'g'), '*');
            } else {
                msg = maskEntireNumber(msg)
            }
            showErrorNotification(msg)
            store.dispatch(setIsComponentOnCall(false));
            store.dispatch(setClick2Call(null));
        }
        else if (resp.response === false) {
            showErrorNotification(resp.message)
            store.dispatch(setIsComponentOnCall(false));
            store.dispatch(setClick2Call(null));
        }
        else if (resp.status === "Exception") {
            Logger.error("webEventhandler Exception")
            showErrorNotification(resp.resp)
            store.dispatch(setIsComponentOnCall(false));
            store.dispatch(setClick2Call(null));
        }
        else {
            let obj = {
                ucid: (resp && resp.message) || '',
                monitorUcid: (resp && resp.message) || '',
                callType: "Manual Dialing",
                callData: "ToolBarManual",
                type: "newCall",
                callerId: phoneNumber || '',
                campaignId: campId || ''
            }
            if (manualCallData !== undefined && manualCallData !== undefined && manualCallData?.campaign && manualCallData?.campaign.split("~")[1] || campaign !== undefined && campaign !== null && campaign?.split("~")[1]) {
                obj["campaignName"] = manualCallData && manualCallData.campaign && manualCallData.campaign.split("~")[1] || campaign.split("~")[1]
            }
            if (uui !== undefined && uui !== null) {
                obj["uui"] = uui
            }
            const currentCallData = store.getState().call.callDetails || {};
            store.dispatch(setCallDetails({ ...obj, ...currentCallData }));
            store.dispatch(setIsComponentOnCall(true));
            store.dispatch(setReUpdateTimer(true));
        }
        store.dispatch(loading(false));
    } catch (e) {
        Logger.error(e);
        store.dispatch(loading(false));
        store.dispatch(setClick2Call(null));
        showErrorNotification("Manual Dial Failed")
    }
}

export function appendNewObjWithCallData(object) {
    const callData = store.getState().call.callDetails;
    const reduxAudioFile = callData?.audioFile || '';
    const newCallDetails = {
        ...store.getState().call.callDetails, ...object,
        audioFile: (object && object.busyAgentData && object.busyAgentData.audioFile) ? object.busyAgentData.audioFile : (reduxAudioFile ? reduxAudioFile : '')
    }
    store.dispatch(setCallDetails(newCallDetails));  // updating call details on busy event 
}

export function convertingToDateTimeStringFormat() {
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let currentDateTimeString = currentDate.toString();
    currentDateTimeString = currentDateTimeString.split('GMT');
    currentDateTimeString = currentDateTimeString[0].split(` ${currentYear}`);
    currentDateTimeString = `${currentDateTimeString[0]}${currentDateTimeString[1]}IST ${currentYear}`;
    return currentDateTimeString
}
export function timeStampToLocalTime(timeStamp) {
    const timestampstring = Number(timeStamp);
    const date = new Date(timestampstring);
    const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
    return formattedDate
}

export async function chatDispositionSaveInUserInactivity(disposition, comment, monitorUcid, chatCustSessionId) {
    let data = {
        disposition: disposition,
        comment: comment || '',
        monitoUcid: monitorUcid
    }
    let dispData = data
    let activeChat = store.getState().digital.answeredChats[chatCustSessionId]
    console.log(activeChat);
    let res = await MessageService.disposeChat(data, chatCustSessionId)
    if (res.resp === "Success") {
        if (store.getState().toolbar.showMinimizedCall) {
            store.dispatch(minimizeCall(false))
            store.dispatch(setIsComponentOnCall(true));
            store.dispatch(setIsCallAttended(true));
        }
        // after chat disposition success making disposition value to null
        let disObj = structuredClone(store.getState().toolbar.multiDisposition);
        disObj.disp1 = null
        disObj.disp2 = null
        disObj.disp3 = null
        disObj.disp4 = null
        disObj.disp5 = null

        disObj.disp1SelectedValue = null
        disObj.disp2SelectedValue = null
        disObj.disp3SelectedValue = null
        disObj.disp4SelectedValue = null
        disObj.disp5SelectedValue = null

        store.dispatch(setDispositionReqbody(null))
        store.dispatch(handleMultiDisposition(disObj))

        showSuccessNotification("Chat Disposed Successfully");
        Logger.info("chat disposed successfully")
        handleScreenPopClose(chatCustSessionId, 'chat')
        handleChatScreenPopCloseOnUserInactivity(chatCustSessionId)
        if (Object.values(store.getState().digital.answeredChats).length <= 1) {
            data = {
                mode: store.getState().toolbar.agent.mode,
                campId: activeChat.chatDetails?.campaignId
            }
            if (store.getState().toolbar.agent.mode === 'blended') {
                if (!store.getState().toolbar.showMinimizedCall && !store.getState().call.isComponentOnCall) {
                    agentReleaseAfterCompleteUserInactivity(data, "disposition", chatCustSessionId)
                }
            }
            else {
                agentReleaseAfterCompleteUserInactivity(data, "disposition", chatCustSessionId)
            }
        }
        if (Object.values(store.getState().digital.answeredChats).length <= 1) {
            updateTimer(true);
        }
        let stringifiedCurrentChat = "";
        for (const [index, item] of activeChat.currentChat.entries()) {
            if (item.type !== "collectUserInfo" && item.type !== "storeUserInfo" && item.agentId !== 'IVR') {
                if (item.agent === "true") {
                    stringifiedCurrentChat += ` ${timeStampToLocalTime(item.ts)}, <b> ${item.agentId === 'IVR' ? "BOT" : "Agent"} </b> : ${item.msg} /nextLine/`;
                }
                else if (activeChat.chatDetails.channelType !== "Web") {
                    stringifiedCurrentChat += ` ${timeStampToLocalTime(item.ts)}, <b> Customer </b> :  ${item.msg} /nextLine/`;
                } else if (index !== 3 && index !== 4) {
                    stringifiedCurrentChat += ` ${timeStampToLocalTime(item.ts)}, <b> Customer </b> :  ${item.msg} /nextLine/`;
                }
            }
        }
        let modifiedactiveChat = { ...activeChat, monitorUcid: activeChat.chatDetails.monitorUcid, sessionId: activeChat.chatCustSessionId, did: activeChat.chatDetails.did, skillName: activeChat.chatDetails.skill, Transcript: stringifiedCurrentChat, ucid: activeChat.chatDetails.monitorUcid, callEndTime: new Date().toISOString(), callStatus: "Answered" }
        console.log(modifiedactiveChat, dispData.disposition, dispData.comment)
        aToolbar !== undefined && aToolbar.trigger("disposeChat", [modifiedactiveChat, dispData.disposition, dispData.comment]);
    } else {
        showErrorNotification("Failed to Dispose the Chat");
        Logger.info("Failed to dispose the chat")
    }
    store.dispatch(handleChatRemove({ chatCustSessionId: chatCustSessionId }));
}

export function handleEndBeep() {
    try {
        let endBeep = document.getElementById('endBeepAudio');
        if (endBeep) {
            console.log("playing end beep");
            endBeep.play();
        } else {
            console.log("end beep audio element not found");
        }
    } catch (e) {
        console.log("Unable to play end beep", e)
    }
}
export function handleTranscribe(message) {
    try {
        let key = message.ucid || null;
        let value = message.text || "";
        let aiResponse = message.agentAssist || null;
        store.dispatch(updateTranscribe({ key, value, timeStamp: message?.ts, channel: message.channel, aiResponse }));
    } catch (e) {
        console.log("Failed to update transcribe event", e)
    }
}

export function handleTranscribeTab() {
    try {
        const ROLE_AI = getRoleStatus("ROLE_AI");
        const AGENT_TRANSCRIBE = ((getParam('VOICE_TRANSCRIPTION') === 'true' && ROLE_AI) || false);
        if (AGENT_TRANSCRIBE) {
            store.dispatch(addNewTab('AgentAssist'))
            store.dispatch(setActiveTab('AgentAssist'))
        }
    } catch (e) {
        console.error("Error while handling transcribe tab",)
    }
}
export function removeTranscribeTab() {
    const ROLE_AI = getRoleStatus("ROLE_AI");
    const AGENT_TRANSCRIBE = ((getParam('VOICE_TRANSCRIPTION') === 'true' && ROLE_AI) || false);
    if (AGENT_TRANSCRIBE) {
        store.dispatch(removeTab('AgentAssist'));
    }

}